// extracted by mini-css-extract-plugin
export var closeButton = "_lk-1";
export var closeX = "_lk-3";
export var container = "_lk-0";
export var image = "_lk-2";